// Mock data for Legal Documents Specialist landing page

export const companyInfo = {
  name: "Legal Document Specialist",
  tagline: "California-Based Legal Support Services Nationwide",
  location: "Palm Springs, CA",
  coverage: "Serving All 50 States",
  phone: "(760) 866-9182",
  email: "support@legaldocspecialist.com",
  address: "225 South Civic Drive, Ste 2-16",
  city: "Palm Springs",
  state: "CA",
  zip: "92262",
  fullAddress: "225 South Civic Drive, Ste 2-16, Palm Springs, CA 92262",
  hours: "Monday-Friday 8:00 AM - 6:00 PM PST"
};

export const services = [
  {
    id: 1,
    title: "Attorney Service",
    description: "Our primary service - comprehensive litigation support platform designed for legal professionals. Highly effective professionals trained and equipped to manage high-volume legal document services.",
    features: ["LegalConnect Platform", "High-Volume Processing", "Dedicated Legal Specialists", "End-to-End Solutions", "Seamless Integration", "Coast-to-Coast Coverage"],
    icon: "Scale",
    hasPage: true,
    pageUrl: "/attorney-service",
    isPrimary: true
  },
  {
    id: 2,
    title: "Process Serving",
    description: "Professional process serving throughout California with same-day options available.",
    features: ["Same-Day Service Available", "Statewide Coverage", "Professional Servers", "Digital Proof of Service"],
    icon: "FileText",
    hasPage: true,
    pageUrl: "/process-serving"
  },
  {
    id: 3,
    title: "Court Filing",
    description: "Professional court filing services with both e-filing and traditional filing options.",
    features: ["E-Filing & Traditional", "Same-Day Filing", "All California Courts", "Filing Confirmations"],
    icon: "Building",
    hasPage: true,
    pageUrl: "/court-filing"
  },
  {
    id: 4,
    title: "County Recording",
    description: "Professional county recording services for real estate documents, liens, and official recordings.",
    features: ["All 58 CA Counties", "Real Estate Documents", "Lien Recording", "Notary Services"],
    icon: "Upload",
    hasPage: true,
    pageUrl: "/county-recording"
  },
  {
    id: 5,
    title: "Skip Tracing",
    description: "Professional skip tracing and people location services throughout California.",
    features: ["Advanced Database Search", "Legal Compliance", "Detailed Reports", "85% Success Rate"],
    icon: "Search",
    hasPage: true,
    pageUrl: "/skip-tracing"
  },
  {
    id: 6,
    title: "Document Retrieval",
    description: "Professional document retrieval from California courts, government agencies, and public records.",
    features: ["Court Records", "Public Records", "Government Documents", "Fast Turnaround"],
    icon: "Archive",
    hasPage: true,
    pageUrl: "/document-retrieval"
  }
];

export const testimonials = [
  // Testimonials will be added by the team later
];

export const credentials = [
  {
    title: "Registered Process Servers",
    description: "All our process servers are properly registered in the counties where they operate nationwide"
  },
  {
    title: "Bonded & Insured",
    description: "Fully bonded and insured for your protection and peace of mind"
  },
  {
    title: "Nationwide Coverage",
    description: "Serving all 50 states with local expertise and nationwide reach"
  },
  {
    title: "Professional Experience",
    description: "Over 22 years of experience serving law firms and self-represented individuals"
  }
];

export const faqs = [
  {
    question: "How quickly can documents be served?",
    answer: "We offer four service levels for **service attempts**: **Routine** (4 days), **Priority** (Next Business Day), **Urgent** (Same Day), and **On-Demand** (under 2 hours). Please note: These timelines refer to our attempts to serve documents. We cannot guarantee successful service as this depends on the availability and cooperation of the person being served."
  },
  {
    question: "Do you serve documents outside of California?",
    answer: "Yes! We're based in Palm Springs, California, but we help our California clients execute legal support services nationwide across all 50 states. Our registered process servers operate in jurisdictions throughout the country."
  },
  {
    question: "What types of legal documents do you handle?",
    answer: "We handle all types of legal documents including summons, complaints, subpoenas, court orders, family law documents, and more."
  },
  {
    question: "How do I get proof that documents were served?",
    answer: "We provide detailed proof of service documents with GPS Data, timestamps, and complete service details as required by law."
  },
  {
    question: "What are your rates?",
    answer: "Our rates vary based on the type of service, location, and urgency. Contact us for a detailed quote tailored to your specific needs."
  }
];

// LegalConnect Attorney Service Data
export const legalConnectServices = [
  {
    id: 1,
    title: "E-Filing",
    description: "Electronic filing services for all California courts with instant confirmations and error checking.",
    icon: "Upload"
  },
  {
    id: 2,
    title: "E-Service",
    description: "Secure electronic service of legal documents with delivery tracking and compliance reporting.",
    icon: "Send"
  },
  {
    id: 3,
    title: "Process Service",
    description: "Professional process serving with registered and bonded servers throughout California.",
    icon: "FileText"
  },
  {
    id: 4,
    title: "Court Filing",
    description: "Traditional court filing services with same-day processing and document review.",
    icon: "Building"
  },
  {
    id: 5,
    title: "Document Retrieval",
    description: "Fast and accurate retrieval of court documents and case files from any California court.",
    icon: "Download"
  },
  {
    id: 6,
    title: "Courtesy Copy Delivery",
    description: "Professional delivery of courtesy copies to judges, opposing counsel, and other parties.",
    icon: "Mail"
  },
  {
    id: 7,
    title: "Secretary of State Filing",
    description: "Complete secretary of state filing services for business formations and compliance.",
    icon: "Building2"
  },
  {
    id: 8,
    title: "County Recording",
    description: "Professional county recording services for deeds, liens, and official documents.",
    icon: "Archive"
  },
  {
    id: 9,
    title: "Writ Service",
    description: "Specialized writ service including executions, attachments, and garnishments.",
    icon: "Gavel"
  },
  {
    id: 10,
    title: "Skip Tracing",
    description: "Professional investigation and location services using comprehensive databases.",
    icon: "Search"
  }
];

export const legalConnectFeatures = [
  {
    title: "Intuitive Dashboard",
    description: "Modern, user-friendly interface that makes order management simple and efficient."
  },
  {
    title: "Coast-to-Coast Access",
    description: "Comprehensive court access nationwide with local expertise in all 50 states."
  },
  {
    title: "Rock-Solid Security",
    description: "Bank-level security protocols to protect your sensitive legal documents and data."
  },
  {
    title: "Seamless Integration",
    description: "Direct integration with popular legal software including case management systems."
  },
  {
    title: "Real-Time Tracking",
    description: "Track all orders and services in real-time with automated status updates."
  },
  {
    title: "24/7 Support",
    description: "Dedicated customer support team available around the clock for urgent matters."
  },
  {
    title: "Personalized Task Management",
    description: "Each legal secretary or paralegal can access and manage only their assigned tasks. No wasted time navigating through the entire firm's assignments to find their specific work items."
  },
  {
    title: "Triple Your Productivity",
    description: "Enter case information once and all subsequent assignments branch from there. All current and completed assignments, including documents, conformed copies, proofs of service, and invoices are at your fingertips. Documents are uploaded to secure AWS Cloud and dispatched electronically, eliminating in-house printing costs."
  }
];